import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';

import Button from 'modules/_shared/components/Buttons';

import { useEditTradingOfferOperationStatusModal } from '../context/EditTradingOfferOperationStatusModalContext';

const EditTradingOfferOperationStatusModalFooter: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = useEditTradingOfferOperationStatusModal();

  return (
    <Modal.Footer className="d-flex justify-content-end">
      <Button
        onClick={actions.handleUpdateTradingOfferOperationStatus}
        disabled={!data.selectedStatusOption}
        text={t('Update')}
        lgSize
      />
    </Modal.Footer>
  );
};

export default EditTradingOfferOperationStatusModalFooter;
